export default __webpack_public_path__ + "static/media/higher_primary_logo_url_tagline_reversed.85c62186.svg";